import templateUrl from './payroll-invoice-dashboard.component.html'
import './payroll-invoice-dashboard.component.less'

export const PayrollInvoiceDashboardComponent = {
    bindings: {
        page: "<",
        dismiss: "&onDismiss",
        changePage: "&onChangePage"
    },
    controllerAs: "vm",
    controller: class PayrollInvoiceDashboardComponent {
        $onInit() {
            this.setUpdatedPageData(this.page)
        }
        $onChanges(changesObj) {
            if (changesObj.page) {
                this.setUpdatedPageData(this.page)
            }
        }
        setUpdatedPageData(page) {
            this.pageNumber = page.PageIndex + 1
            this.pageSize = page.PageSize
            this.totalEntityCount = page.TotalEntityCount
            this.payrollInvoices = page.Entities
        }
    },
    templateUrl
}
